exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-fields{display:-webkit-box;display:-ms-flexbox;display:flex;gap:10px;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.inline-fields .el-form-item:nth-child(1) .el-form-item__label::before{content:\"* \";color:#F56C6C}.inline-fields .el-form-item:nth-child(2) .el-form-item__content,.inline-fields .el-form-item:nth-child(3) .el-form-item__content{margin-left:0 !important}\n", ""]);

// exports
